const ns = "PORTAL_PERSON";
export const RECEIVE = `${ns}_RECEIVE`;
